import api from '../lib/api'
import assign from 'lodash.assign'

const name = 'group-result'

export default {
  name,
  namespaced: true,
  state: {
    data: {},
    qrCode: ''
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async 'data:get' ({ commit,rootState }) {
      const {groupId} = rootState.route.query
      const {data} = await api.signUp.getQrcode(groupId)()
      commit('set', {qrCode: data})
    },
    async init ({ dispatch }) {
      console.log('init group-result')
      await dispatch('data:get')
    }
  }
}
